export default {"src":"/_next/static/media/Empty_Risk.ae9626e4.svg","height":140,"width":140,"blurWidth":0,"blurHeight":0};